import React, { useEffect } from 'react';
import { SettingsInlineButton } from '@views/Settings/components';
import { useDispatch, useSelector } from 'react-redux';
import { selectBirthdayRequestRecommendations } from '@repo/redux/reducers/data/birthdays';
import { fetchBirthdayRequestRecommendations } from '@repo/redux/actions/birthdays';
import { openModal } from '@repo/redux/actions/ui';
import styles from './RequestMissingBirthdays.module.scss';

export default function RequestMissingBirthdays() {
  const dispatch = useDispatch();
  const missingBirthdays = useSelector(selectBirthdayRequestRecommendations);

  useEffect(() => {
    dispatch(fetchBirthdayRequestRecommendations());
  }, []);

  if (!missingBirthdays.length) {
    return null;
  }

  return (
    <div className={styles.container}>
      Request Missing Birthdays
      <SettingsInlineButton onClick={() => dispatch(openModal('requestMissingBirthdays'))}>
        Request
      </SettingsInlineButton>
      <p>
        View missing birthdays for close relationships and ask some or all of those people to add
        their birthday in one click.
      </p>
    </div>
  );
}
